import React, { useState, useRef, useEffect } from "react"
import PropTypes from "prop-types"
import Button from "../Button/Button"
import Image from "../Image/Image"
import useIntersectionObserver from "../../../hooks/useIntersection"
import { imageConstants } from "../../../constants/image.constants"
import useImage from "../../../hooks/useImage"
import * as styles from "./InlineView-tw-styles"
import "../../../styles/ableplayer.css"

const AblePlayer = props => {
  const {
    poster,
    videoId,
    isImageToggle,
    variant,
    isButtonBlack = false,
  } = props

  const { altText, foregroundImg } = useImage(poster)
  const [isPlayVideo, setVideoState] = useState(false)

  const [isCookie, setCookie] = useState(false)
  const [isCookieBannerClose, setIsCookieBannerClose] = useState(false)

  useEffect(() => {
    document.cookie.includes('GA') && setCookie(true)
    document.cookie.includes('OptanonAlertBoxClosed') && setIsCookieBannerClose(true)

    if(!isCookieBannerClose) {
      const interval = setInterval(() => {
        if(!isCookie){
          document.cookie.includes('GA') && setCookie(true)
          document.cookie.includes('OptanonAlertBoxClosed') && setIsCookieBannerClose(true)
          return;
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  },[isCookieBannerClose]); 

  var playerReady = false

  const style = styles[variant] || styles.defaultStyle
  // if iframe is in viewport, then render
  const ref = useRef(null)
  useIntersectionObserver(ref, {})

  const playPauseVideo = () => {
    setVideoState(!isPlayVideo)
  }
  const showPlayCls = () => {
    if (!isPlayVideo) {
      return style?.showImg
    } else {
      return style?.hideImg
    }
  }
  const showVideoCls = () => {
    if (isPlayVideo) {
      return style?.videoFrame
    } else {
      return style?.videoFrameHide
    }
  }
  useEffect(() => {
    var scripts = document.getElementById('ablePlayer');
    if (document.getElementsByTagName('video')?.length > 0 && !scripts) {
      var header = document.getElementsByTagName("head")['0'];
      var scriptElement = document.createElement('script');
      scriptElement.type = 'text/javascript';
      scriptElement.src = '/ablePlayer/build/ableplayer.js';
      scriptElement.id = 'ablePlayer'
      header.appendChild(scriptElement);
    }
  })

  useEffect(() => {
    if (isPlayVideo) {
      let video = document.getElementById(videoId + "_youtube")
      if (video?.src) {
        var player = YT.get(videoId + "_youtube");
        player?.playVideo();
      }
    }
  }, [isPlayVideo])
  function renderHomePageVideo() {
    return (
      <div className={style?.videoWrapper}>
        {isImageToggle && isCookie && (
          <Button className={showPlayCls()} onClick={playPauseVideo}>
            <Image
              contentfulImage={foregroundImg}
              className={`${style?.playBtnImg} event_video_play`}
              alt={altText}
            />
            {isButtonBlack ? (
              <Image
                contentfulImage={imageConstants.playBtnBlack}
                className={style?.playButton}
              />
            ) : (
              <Image
                contentfulImage={imageConstants.playBtnWhite}
                className={style?.playButton}
              />
            )}
          </Button>
        )}
        <div
          className={isImageToggle ? showVideoCls() : style?.videoframe}
          ref={ref}
        >
          <div className={isPlayVideo ? "" : "hidden"}>
            {typeof window !== "undefined" && isCookie &&
              window.onYouTubeIframeAPIReady && (
                <video
                  id={videoId}
                  data-skin="2020"
                  data-able-player
                  data-heading-level={2}
                  data-youtube-id={videoId}
                  preload="auto"
                  autoPlay={false}
                  className={[style?.videoItem, "event_video_play"].join(" ")}
                  width={isImageToggle ? "700" : "100%"}
                  height={isImageToggle ? "400" : "100%"}
                ></video>
              )}
          </div>
        </div>
      </div>
    )
  }

  const renderIframe = () => {
    return <div className={style?.videoCntr}>{renderHomePageVideo()}</div>
  }

  return <div>{renderIframe()}</div>
}

AblePlayer.propTypes = {
  poster: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  title: PropTypes.string,
  youtubeVideoId: PropTypes.string,
  videoId: PropTypes.string,
  style: PropTypes.object,
  isImageToggle: PropTypes.bool,
  videoLink: PropTypes.string,
  image: PropTypes.object,
  variant: PropTypes.string,
  isButtonBlack: PropTypes.bool,
}

export default AblePlayer
